module.exports = __webpack_public_path__ + "8fe3b3cc9b097affe77d4a5d59277e3f.png";